import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'app-common-date-picker',
    standalone: true,
    imports: [
        FormsModule,
        MatDatepicker,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatFormField,
        MatIcon,
        MatIconButton,
        MatInput,
        MatPrefix,
        MatSuffix,
        ReactiveFormsModule,
    ],
    templateUrl: './common-date-picker.component.html',
    styleUrl: './common-date-picker.component.scss'
})

// выбор даты с возможностью переключения на день позже\раньше
export class CommonDatePickerComponent implements OnInit{
    @Input({required: true}) dateControl!: FormControl;

    // выбор даты на день раньше или на день позже
    otherDay(day: number): void {
        const currentDate = this.dateControl.value;
        if (currentDate) {
            const nextDate = new Date(currentDate);
            nextDate.setDate(nextDate.getDate() + day);
            this.dateControl.setValue(nextDate);
        }
    }

    ngOnInit(): void {
        this.dateControl.setValue(new Date());
    }
}
